module.exports = __webpack_public_path__ + "static/media/complete.c5eb9eab.jpg";